import { FEEDERLISTS } from "../_constants/actionConstants";
import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

/**
 * Action creator. Fetches feederLists for the requested project.
 * @param {number} projectId
 */
const getAll = (projectId) => async (dispatch) => {
  dispatch({ type: FEEDERLISTS.FETCH });

  const apiEndpoint =
    BASE_URL + "/api/ProjectAdmin/GetFeederLists/?projectId=" + projectId;
  try {
    const res = await axios.get(apiEndpoint);
    const {
      projKeywordList,
      projLaborList,
      projLaborCrewList,
      projContractorList,
      projEquipList,
      projLocationList,
      projItemList,
      projCcoList,
      projPendingIssueList,
    } = res.data;
    dispatch({
      type: FEEDERLISTS.FETCH_FULFILLED,
      projectId,
      projKeywordList,
      projLaborList,
      projLaborCrewList,
      projContractorList,
      projEquipList,
      projLocationList,
      projItemList,
      projCcoList,
      projPendingIssueList,
    });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = FEEDERLISTS.FETCH_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(FEEDERLISTS.FETCH_REJECTED, err.response.data);
  }
};

const getAllStatic = () => async (dispatch, getState) => {
  const locationTypeList = getState().feederLists.locationTypeList;
  const fieldTestTypes = getState().feederLists.fieldTestTypes;
  const miscMaterialsUnitsOfMeasure = getState().feederLists.miscMaterialsUnitsOfMeasure;
  const tradeList = getState().feederLists.tradeList;

  // Skip fetch if all 4 lookup lists already exist
  if (
    locationTypeList &&
    fieldTestTypes &&
    miscMaterialsUnitsOfMeasure &&
    tradeList &&
    locationTypeList.length > 0 &&
    fieldTestTypes.length > 0 &&
    tradeList.length > 0 &&
    miscMaterialsUnitsOfMeasure.length > 0
  )
    return;

  dispatch({ type: FEEDERLISTS.FETCH_LOOKUP_LISTS });
  const apiEndpoint = BASE_URL + "/api/ProjectAdmin/GetLookupLists";
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: FEEDERLISTS.FETCH_LOOKUP_LISTS_FULFILLED, ...res.data });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = FEEDERLISTS.FETCH_LOOKUP_LISTS_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.error(FEEDERLISTS.FETCH_LOOKUP_LISTS_REJECTED, err.response.data);
  }
};

const getAllTrades = () => async (dispatch, getState) => {
  // If tradeList already exists, skip fetch and return
  if ((getState().feederLists.tradeList || []).length > 0) return;

  dispatch({ type: FEEDERLISTS.FETCH_ALL_TRADES });

  const apiEndpoint = BASE_URL + "/api/Labors/GetAllTrades";
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: FEEDERLISTS.FETCH_ALL_TRADES_FULFILLED,
      tradeList: res.data,
    });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = FEEDERLISTS.FETCH_ALL_TRADES_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.error(FEEDERLISTS.FETCH_ALL_TRADES_REJECTED, err.response.data);
  }
};

const getLocationTypes = (projectId) => async (dispatch, getState) => {
  // If locationTypeList already exists, skip fetch and return
  if ((getState().feederLists.locationTypeList || []).length > 0) return;

  dispatch({ type: FEEDERLISTS.FETCH_LOCATION_TYPES });

  const apiEndpoint = BASE_URL + "/api/Locations/GetLocationTypes";
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: FEEDERLISTS.FETCH_LOCATION_TYPES_FULFILLED,
      projectId,
      locationTypeList: res.data,
    });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = FEEDERLISTS.FETCH_LOCATION_TYPES_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(FEEDERLISTS.FETCH_LOCATION_TYPES_REJECTED, err.response.data);
  }
};

const feederListActions = {
  getAll,
  getAllStatic,
  getAllTrades,
  getLocationTypes,
};

export default feederListActions;
